import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
// import { TransitionComponent } from '../shared/transition/transition.component';
import { LoadingComponent } from '../shared/loading/loading.component';

import './home.scss';

@inject('appStore', 'routerStore')
@observer
export class HomeComponent extends Component {

    componentWillUpdate() {
        const { appStore, routerStore } = this.props;

        if (appStore.collections && appStore.collections.length === 1) {
            routerStore.history.push(appStore.collections[0].Link);
        }
    }

    getComponent() {
        const { appStore } = this.props;
        // console.log('getComponent', collections);

        if (appStore.collections && appStore.collections.length) {
            return (
                <div className='home-collections' key='home'>
                    {appStore.collections.map((collection, i) => {
                        return <Link
                            key={collection.ID}
                            to={collection.Link}
                            className='home-item'>
                            <div className='home-iteminner'>
                                <div className='home-itemimage' style={{backgroundImage: `url(${collection.ImageURL}`}} />
                                <div className='home-itemcontent'>
                                    <h3 className='home-itemtitle'>{collection.Title}</h3>
                                    {collection.Description && <p className='home-itemdescription'>{collection.Description}</p>}
                                    <span className='pure-button'>Start</span>
                                </div>
                            </div>
                        </Link>;
                    })}
                </div>
            );
        } else {
            return (
                <LoadingComponent />
            );
        }
    }

    render() {
        return <div className='home'>
            {this.getComponent()}
        </div>;
    }

}



// WEBPACK FOOTER //
// ./src/_home/home.component.js